<template>
  <div>
    <News/>
  </div>
</template>

<script>
import News from "../components/Support/News.vue"
export default {
  components: { News }
}
</script>

<style lang="less" scoped>

</style>
